var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.navBar)?_c('navBar',{attrs:{"title":_vm.title}}):_vm._e(),(_vm.token)?_c('router-view',{attrs:{"chatVal":_vm.chatVal}}):_vm._e(),(_vm.show && _vm.isOriginHeight)?_c('tabbar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }